/**
 * jsbridge 新老 name 对应关系对象；
 * key 为老 name
 * value 为新 name
 */
export const jsbNameObj = {
  "loginOut": "AXCommonJsApi.logout",
  "isApp": "CloundPersonalJsApi.getUserInfo",
  "getTokenAndMerchantNo": "CloundPersonalJsApi.getUserInfo",
  "CloudWorkbenchJsApi.logout": "AXCommonJsApi.logout",
  "downloadImage": "AXCommonJsApi.downloadImage",
  "getAppVersion": "AXCommonJsApi.getAppVersion",
  "openNewNative": "AXCommonJsApi.openWebView",
  "finishWebAct": "AXCommonJsApi.closeWebView",
  "CloudWorkbenchJsApi.closeWebview": "AXCommonJsApi.closeWebView",
  "getLocation": "AXCommonJsApi.getLocation",
  "CloudWorkbenchJsApi.setDocTitle": "AXCommonJsApi.setDocTitle",
  "CloudWorkbenchJsApi.goBack": "AXCommonJsApi.goBack",
  "CloudWorkbenchJsApi.openNativeView": "AXCommonJsApi.openNativeView",
  "CloudWorkbenchJsApi.setTitleBarColor": "AXCommonJsApi.setTitleBarColor",
  "setNativeTokenFromH5": "AXCommonJsApi.setNativeTokenFromH5",
  "CloudWorkbenchJsApi.setSensorsTrack": "AXCommonJsApi.setTrack",
  "startFaceRecoginzer": "CloundPersonalJsApi.startFaceRecoginzer",
  "switchMerchant": "CloundPersonalJsApi.switchMerchant",
  "receiveSalary": "CloundPersonalJsApi.receiveSalary",
  "switchMerchantGeneralServers": "CloundPersonalJsApi.switchMerchantGeneralServers",
  "cashOut": "CloundPersonalJsApi.cashOut",
  "saasTrackEvent": "CloundPersonalJsApi.saasTrackEvent",
  "toNotificationPage": "CloundPersonalJsApi.toNotificationPage",
  "showFinalSalary": "CloundPersonalJsApi.showFinalSalary",
  "appealSuccess": "CloundPersonalJsApi.appealSuccess",
  "CloudWorkbenchJsApi.updateCheckList": "CloundPersonalJsApi.updateCheckList",
  "CloudWorkbenchJsApi.openRiskCheckListPage": "CloundPersonalJsApi.openRiskCheckListPage",
  "CloudWorkbenchJsApi.dailyStaffOperation": "CloundPersonalJsApi.dailyStaffOperation",
  "CloudWorkbenchJsApi.punchCardAuditListPage": "CloundPersonalJsApi.punchCardAuditListPage",
  "CloudWorkbenchJsApi.getCommonInfo": "CloundPersonalJsApi.getCommonInfo",
  "getUserInfo": "CloundPersonalJsApi.getUserInfo",
  "CloudWorkbenchJsApi.getBUserInfo": "CloundPersonalJsApi.getBUserInfo",
}
